import { render } from "./PrivacyAgreement.vue?vue&type=template&id=4612c7aa&scoped=true"
import script from "./PrivacyAgreement.vue?vue&type=script&lang=js"
export * from "./PrivacyAgreement.vue?vue&type=script&lang=js"

import "./PrivacyAgreement.vue?vue&type=style&index=0&id=4612c7aa&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4612c7aa"]])

export default __exports__